import React from 'react';

type CounterOfferStepperProps = {
  totalSteps: number;
  activeIndex: number;
  onPrevious: () => void;
  onNext: () => void;
};

export const CounterOfferStepper: React.FC<CounterOfferStepperProps> = ({
  totalSteps,
  activeIndex,
  onPrevious,
  onNext,
}) => {
  if (totalSteps <= 1) {
    return null;
  }

  const current = activeIndex + 1;

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-[#767676]" style={{ fontFamily: 'var(--ep-font-avenir)' }}>
        {current} / {totalSteps}
      </span>
      <button
        onClick={onPrevious}
        disabled={activeIndex === 0}
        className="flex items-center justify-center p-1 disabled:opacity-30 disabled:cursor-not-allowed hover:opacity-70 transition-opacity cursor-pointer"
        aria-label="Previous counteroffer"
      >
        <span className="text-[#113D7B] text-lg font-semibold" style={{ fontFamily: 'var(--ep-font-avenir)' }}>
          &lt;
        </span>
      </button>
      <button
        onClick={onNext}
        disabled={activeIndex === totalSteps - 1}
        className="flex items-center justify-center p-1 disabled:opacity-30 disabled:cursor-not-allowed hover:opacity-70 transition-opacity cursor-pointer"
        aria-label="Next counteroffer"
      >
        <span className="text-[#113D7B] text-lg font-semibold" style={{ fontFamily: 'var(--ep-font-avenir)' }}>
          &gt;
        </span>
      </button>
    </div>
  );
};
